<template>
  <div class="container">
    <div class="row">
      <div class="column">
        <div class="table-header">
          <h3>
            Live Statuses
          </h3>
        </div>
        <table id="statusTable">
          <thead>
            <tr>
              <th class="hide-td">Node</th>
              <th>Machine</th>
              <th>Size</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <machine-row
              v-for="status in statuses"
              v-bind:key="status.id"
              :canSms='canSms'
              :machine="status"
              :template="template"
              :themeConfig="themeConfig">
              </machine-row>
          </tbody>
        </table>
        <modal name="alertModal"
          :height="auto"
          :width="360"
          @before-close="beforeAlertClose">

          <header>
            <span class="hero fa-stack fa-lg">
              <i class="fa fa-circle fa-stack-2x"></i>
              <i class="fa fa-bell fa-stack-1x fa-inverse"></i>
            </span>

            <h2>
              Get Live Updates
            </h2>
          </header>

          <div class="container">
            <div class="row">
              <fieldset>
                <label >Notify you when this machine is available via:</label>

                <template v-if="canSms">
                  <select v-model="form.isEmail" @change="alertTypeChange">
                      <option
                          v-for="(alertType, idx) in availableAlerts"
                          :value="alertType.isEmail"
                          :key="idx">{{alertType.title}}</option>
                  </select>
                </template>

                <input type="email" placeholder="your@email.com" v-model="form.email" v-if="form.isEmail">
                <!-- <input type="text" placeholder="310-555-5555" v-model="form.phone" v-else> -->
                <!-- <masked-input v-model="form.phone" mask="111 111-1111" type="text" v-else /> -->
                <masked-input v-model="form.phone" mask="(111) 111-1111" placeholder="phone number" type="text" v-else />

                <label for="commentField">Send update...</label>
                <select v-model="form.machineTimeBeforeComplete">
                    <option
                        v-for="(trigger, idx) in alertTriggers"
                        :value="trigger.remainingSeconds"
                        :key="idx">{{trigger.title}}</option>
                </select>

                <button @click="submit" :disabled="modalButtonDisabled">Alert Me</button>
              </fieldset>
            </div>
          </div>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import MachineRow from "./MachineRow";
import MaskedInput from "vue-masked-input";
import { submitMachineSubscription } from "../services/data";

export default {
  name: "Subcribe",
  props: {
    statuses: Object,
    template: Object,
    canSms: Boolean,
    themeConfig: Object,
  },
  data() {
    return {
      auto: "auto",
      isLoading: false,
      machine: null,
      machineTemplate: null,
      rowRef: null,
      form: {
        machineTimeBeforeComplete: "P0Y0M0DT0H0M0S",
        isEmail: true
      },
      availableAlerts: [
        {
          title: "Email",
          isEmail: true
        },
        {
          title: "Text SMS",
          isEmail: false
        }
      ],
      alertTriggers: [
        {
          title: "when machine is finished",
          remainingSeconds: "P0Y0M0DT0H0M0S"
        },
        {
          title: "has 1 minute left",
          remainingSeconds: "P0Y0M0DT0H1M0S"
        },
        {
          title: "has 3 minutes left",
          remainingSeconds: "P0Y0M0DT0H3M0S"
        },
        {
          title: "has 5 minutes left",
          remainingSeconds: "P0Y0M0DT0H5M0S"
        }
      ],
      siteKey: window.siteKey,
    };
  },
  components: {
    "machine-row": MachineRow,
    MaskedInput
  },
  mounted() {
    // https://mottie.github.io/tablesorter
    $("#statusTable").tablesorter({
        sortList: [[0,0]],
        sortReset: true,
        // widgets: ["saveSort"]
    });
  },
  updated() {
    // Tablesorter must be updated after tbody has rows
    $("#statusTable").trigger("update");
  },
  computed: {
    validated() {
      if (this.form.phone || this.form.email) {
        return false;
      }
      return true;
    },

    modalButtonDisabled() {
      if (this.validated || this.isLoading) {
        return true;
      }
      return false;
    }
  },
  methods: {
    updateStatus() {
      $("#statusTable").trigger("update");
    },

    alertTypeChange() {
      if (this.form.isEmail) {
        this.$delete(this.form, "phone");
      } else {
        this.$delete(this.form, "email");
      }
    },

    resetAlertForm() {
      this.$delete(this.form, "phone");
      this.$delete(this.form, "email");
      this.form.isEmail = true;
      this.form.machineTimeBeforeComplete = "P0Y0M0DT0H0M0S";
    },

    submit() {

      this.isLoading = true;

      grecaptcha.ready(() => {
        grecaptcha.execute(this.siteKey, {action: 'submit'}).then((recaptchaToken) => {
          this.form.recaptchaToken = recaptchaToken

          let alertType = this.form.isEmail ? 'email' : 'phone';
          console.log('event:created-' + alertType + '-alert');
          this.$ga.event({
            eventCategory: 'room ' + this.$route.query.room,
            eventAction: 'created-' + alertType + '-alert'
          });

          submitMachineSubscription(
            this.$route.query.room,
            this.machine.id,
            this.form,
            this.template
          ).then(response => {
            this.rowRef.hasSubscribed = true;
            this.$modal.hide("alertModal");
          }).catch(e => {
            console.log("> e", e);
          }).finally(() => {
            this.isLoading = false;
          });
        });
      });
    },

    showAlertModal(machine, template, ref) {
      this.machine = machine;
      this.machineTemplate = template;
      this.rowRef = ref;

      console.log('event:create-alert-opened');
      this.$ga.event({
        eventCategory: 'room ' + this.$route.query.room,
        eventAction: 'create-alert-opened'
      });

      this.resetAlertForm();
      this.$modal.show("alertModal");
    },

    hideAlertModal() {
      this.$modal.hide("alertModal");
    },

    beforeAlertClose(event) {
      console.log('event:create-alert-closed');
      this.$ga.event({
        eventCategory: 'room ' + this.$route.query.room,
        eventAction: 'create-alert-closed'
      });
    }
  }
};
</script>

<style scoped>
.table-header {
  padding: 1em 1em 0 1em;
  margin-top: 2em;
  background: white;
}

table thead th:focus {
    outline: none;
}

table thead tr .tablesorter-headerUnSorted {
    background-image: url(../../static/black-unsorted.gif);
    background-repeat: no-repeat;
    background-position: center right;
    cursor: pointer;
}

table thead tr .tablesorter-headerDesc {
  background-image: url(../../static/black-desc.gif);
  background-repeat: no-repeat;
  background-position: center right;
  cursor: pointer;
}

table thead tr .tablesorter-headerAsc {
  background-image: url(../../static/black-asc.gif);
  background-repeat: no-repeat;
  background-position: center right;
  cursor: pointer;
}

h3 {
  margin-bottom: 0;
}

.row select,
.row input,
.row button {
  margin-bottom: 0;
}

button {
  width: 100%;
  padding: 0 1.5rem;
  background-color: #d0011b;
  border: 1px solid #d0011b;
}

button[disabled] {
  background: rgb(236, 236, 236);
  border-color: rgb(198, 204, 207);
  color: #303233;
  opacity: 1;
}

h2 {
  margin: 0.5em auto;
  text-align: center;
  font-size: 22px;
}

header {
  padding: 0.875em 0;
  background: #f3a537;
  color: white;
}

.fa-inverse {
  color: #f3a537;
}

header span {
  display: block;
  font-size: 20px;
  margin-bottom: 10px;
  width: 100%;
}

/* .v--modal-box.v--modal {
  width: 400px !important;
} */

.v--modal-box .container {
  padding: 0 2em;
  max-width: 340px;
}

.v--modal-box.v--modal {
  border-radius: 10px;
  background: blue;
}

.v--modal-box h2 {
  margin-top: 0;
}

.v--modal-overlay select,
.v--modal-overlay input,
.v--modal-overlay button {
  margin-bottom: 0.5rem;
}

.v--modal-overlay fieldset {
  width: 100%;
  padding: 0 0 1em 0;
  margin-bottom: 0;
}

fieldset label,
fieldset button {
  margin-top: 10px;
}

fieldset label {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Subscribe.vue